import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  template: '',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export abstract class StandardComponentBase {
  @ViewChild('targetInputElement', { static: true }) public targetInputElement: ElementRef<HTMLInputElement>;
}
